export default __webpack_public_path__ + "static/media/xpds.cd45724c.png";